export function SET_COUNTRIES({ commit }, [countries]) {
    commit('SAVE_COUNTRIES', [countries])
}

export function SET_COUNTRY({ commit }, [country]) {
    commit('SAVE_COUNTRY', [country])
}

export function SET_COURSES({ commit }, [courses]) {
    commit('SAVE_COURSES', [courses])
}